/**
 * Page popup - fetches and displays a Shopify page in a modal.
 * Buttons with data-open-page-popup and data-url trigger this.
 * Uses the existing .simple-modal in main-product.liquid.
 */
(function () {
  const MODAL = document.querySelector('.simple-modal');
  const BODY = MODAL?.querySelector('.simple-modal__body');

  if (!MODAL || !BODY) return;

  let openedAt = 0;

  function extractContent(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const isRejected = (el) =>
      !!el?.closest?.('.m-age-verifier, m-age-verifier-popup, [id*="age-verifier"]');

    const candidates = [
      () => doc.querySelector('[data-popup-content]'),
      () => doc.querySelector('#MainContent .rte'),
      () => doc.querySelector('main .rte'),
      () => doc.querySelector('#MainContent'),
      () => doc.querySelector('main'),
      () => doc.querySelector('body')
    ];

    for (const pick of candidates) {
      const el = pick();
      if (el && el.innerHTML && el.innerHTML.trim().length > 0 && !isRejected(el)) {
        el.querySelectorAll('script').forEach((s) => s.remove());
        return el.innerHTML;
      }
    }
    return null;
  }

  function openModal() {
    MODAL.style.display = 'flex';
    MODAL.classList.add('is-open');
    MODAL.setAttribute('aria-hidden', 'false');

    // focus close button if present
    MODAL.querySelector('.simple-modal__close')?.focus?.();

    openedAt = performance.now();
  }

  function closeModal() {
    MODAL.classList.remove('is-open');
    MODAL.setAttribute('aria-hidden', 'true');
    MODAL.style.display = 'none';
    BODY.innerHTML = '';

    if (MODAL._opener) {
      MODAL._opener.focus?.();
      MODAL._opener = null;
    }
  }

  async function openFromUrl(url, opener) {
    if (!url) return;

    MODAL._opener = opener || null;
    BODY.innerHTML = '<div class="loading">Loading…</div>';
    openModal();

    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const html = await res.text();
      const content = extractContent(html) || '<p>Content could not be extracted.</p>';
      BODY.innerHTML = content;
    } catch (err) {
      console.warn('[Page popup] failed to load:', err);
      BODY.innerHTML = `
        <p style="color:#b00">Unable to load content right now.</p>
        <p><a href="${url}" target="_blank" rel="noopener">Open in a new tab</a></p>
      `;
    }
  }

  // Open triggers
  function handleClick(e) {
    const btn = e.target.closest('[data-open-page-popup]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const url = btn.getAttribute('data-url');
    if (url) openFromUrl(url, btn);
  }

  // ESC closes (only if open)
  function onKey(e) {
    if (e.key === 'Escape' && MODAL.classList.contains('is-open')) {
      closeModal();
    }
  }

  // Robust "outside click" close for drawers/side-rails:
  // pointerdown + capture runs before other handlers can stop propagation
  function onOutsidePointerDown(e) {
    if (!MODAL.classList.contains('is-open')) return;
    if (performance.now() - openedAt < 200) return;

    // Prefer dialog container if present; fall back to BODY
    const dialog =
      MODAL.querySelector('.simple-modal__dialog') ||
      MODAL.querySelector('[role="dialog"]') ||
      BODY;

    const path = e.composedPath?.();
    const clickedInside = path ? path.includes(dialog) : dialog.contains(e.target);

    if (!clickedInside) closeModal();
  }

  // Close button (delegated so it still works if DOM is replaced)
  function onModalClick(e) {
    const closeBtn = e.target.closest('.simple-modal__close');
    if (!closeBtn) return;

    e.preventDefault();
    e.stopPropagation();
    closeModal();
  }

  // Bind listeners
  document.addEventListener('click', handleClick, true);
  document.addEventListener('keydown', onKey, true);

  // outside click close
  document.addEventListener('pointerdown', onOutsidePointerDown, true);

  // close button (delegated)
  MODAL.addEventListener('click', onModalClick, true);
})();